import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import { Grid, Box, LinearProgress, Typography } from '@material-ui/core';
import {
  getPictreeGroupSummaryHokuden,
} from "actions";
import * as H from "helper";

const useStyles = makeStyles((theme) =>
  createStyles({
    tooltip: {
      position: 'absolute',
      top: '8px',
      left: '50%',
      transform: 'translateX(-50%)',
      padding: '5px 10px',
      borderRadius: '4px',
      fontSize: '14px',
      whiteSpace: 'nowrap',
    },
    box: {
      marginTop: theme.spacing(2),
      marginLeft: theme.spacing(1),
      borderRight: "1px solid #dcdcdc",
    },
    boxLast: {
      marginTop: theme.spacing(2),
      marginLeft: theme.spacing(0),
    },
    title: {
      display: "block",
      height: 32,
      fontSize: 14,
    },
    value: {
      paddingTop: 0,
      paddingBottom: 0,
      minWidth: 150,
    },
  })
);

const GroupSummary = ({
  homeDataReportTsuru,
  getPictreeGroupSummaryHokuden,
  dateRangePicTree,
  groupSummaryData,
}) => {
  const classes = useStyles();
  const [initialDataCall, setInitialDataCall] = useState(true);

  useEffect(() => {
    getPictreeGroupSummaryHokuden();
  }, []);

  // useEffect(() => {
  //   if (dateRangePicTree[0] !== null && dateRangePicTree[1]!== null
  //     && initialDataCall) {
  //     getPictreeGroupSummaryHokuden();
  //     setInitialDataCall(false);
  //   }
  // }, [dateRangePicTree]);

  return (
    <Grid container spacing={1}>
      <Grid item sm={12}>
        <Grid container spacing={1}>
          <Grid item sm={6} md={4} lg={2}>
            <div className={classes.box}>
              <Grid container direction={"row"}>
                <Grid item xs={11}>
                  <Typography
                    variant="caption"
                    className={classes.title}
                  >グループ登録数</Typography>
                </Grid>
                <Grid item xs={1} sm={6} md={4}>
                  <Typography variant="h6" className={classes.value}>
                    {groupSummaryData?.groupCount !== undefined
                      ? `${H.FormatNumStrHelper.formatCommaThousand(groupSummaryData.groupCount)}`
                      : "-"}
                  </Typography>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item sm={6} md={4} lg={2}>
            <div className={classes.box}>
              <Grid container direction={"row"}>
                <Grid item xs={11}>
                  <Typography
                    variant="caption"
                    className={classes.title}
                  >グループ登録者数</Typography>
                </Grid>
                <Grid item xs={1} sm={6} md={4}>
                  <Typography variant="h6" className={classes.value}>
                    {groupSummaryData?.groupRegisteredCount !== undefined
                      ? `${H.FormatNumStrHelper.formatCommaThousand(groupSummaryData.groupRegisteredCount)}`
                      : "-"}
                  </Typography>
                </Grid>
              </Grid>
            </div>
          </Grid>
          {/* <Grid item sm={6} md={4} lg={2}>
            <div className={classes.box}>
              <Grid container direction={"row"}>
                <Grid item xs={11}>
                  <Typography
                    variant="caption"
                    className={classes.title}
                  >最多グループ登録</Typography>
                </Grid>
                <Grid item xs={1} sm={6} md={4}>
                  <Typography variant="h6" className={classes.value}>
                    {groupSummaryData.groupData.length > 0
                      ? `${H.FormatNumStrHelper.formatCommaThousand(groupSummaryData.groupData[0].playerCount)}`
                      : "-"}
                  </Typography>
                </Grid>
              </Grid>
            </div>
          </Grid> */}
          {/* <Grid item sm={6} md={4} lg={2}>
            <div className={classes.box}>
              <Grid container direction={"row"}>
                <Grid item xs={11}>
                  <Typography
                    variant="caption"
                    className={classes.title}
                  ></Typography>
                </Grid>
                <Grid item xs={1} sm={6} md={4}>
                  <Typography variant="h6" className={classes.value}>
                    {homeDataReportTsuru.countLedgerAndNoReport  !== undefined
                      ? `${H.FormatNumStrHelper.formatCommaThousand(homeDataReportTsuru.countLedgerAndNoReport)}`
                      : "-"}
                  </Typography>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item sm={6} md={4} lg={2}>
            <div className={classes.box}>
              <Grid container direction={"row"}>
                <Grid item xs={11}>
                  <Typography
                    variant="caption"
                    className={classes.title}
                  ></Typography>
                </Grid>
                <Grid item xs={1} sm={6} md={4}>
                  <Typography variant="h6" className={classes.value}>
                    {homeDataReportTsuru.countNoLedgerAndReport !== undefined
                      ? `${H.FormatNumStrHelper.formatCommaThousand(homeDataReportTsuru.countNoLedgerAndReport)}`
                      : "-"}
                  </Typography>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item sm={6} md={4} lg={2}>
            <div className={classes.box}>
              <Grid container direction={"row"}>
                <Grid item xs={11}>
                  <Typography
                    variant="caption"
                    className={classes.title}
                  ></Typography>
                </Grid>
                <Grid item xs={1} sm={6} md={4}>
                  <Typography variant="h6" className={classes.value}>
                    {homeDataReportTsuru.countNoLedgerAndReport !== undefined
                      ? `${H.FormatNumStrHelper.formatCommaThousand(homeDataReportTsuru.countNoLedgerAndNoReport)}`
                      : "-"}
                  </Typography>
                </Grid>
              </Grid>
            </div>
          </Grid> */}
        </Grid>
      </Grid>
    </Grid>
  );
};

GroupSummary.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  homeDataReportTsuru: state.pictree.homeDataReportTsuru,
  dateRangePicTree: state.page.dateRangePicTree,
  groupSummaryData: state.pictreeHokuden.groupSummaryData,
});

const mapDispatchToProps = (dispatch) => ({
  getPictreeGroupSummaryHokuden: () => dispatch(getPictreeGroupSummaryHokuden()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(GroupSummary));
